<template>
  <Layout>
    <div class="mc-list-header">
      <PageHeader :title="title" :items="items" class="mc-page-three" />

      <div class="clearfix mc-btn-group__list mc-btn-group__list--detail">
        <div class="float-end">
          <McButtonBack @click="handleBack" />
        </div>
      </div>
    </div>

    <div class="clearfix mb-4">
      <h4 class="card-title float-start">
        {{ $t('master.parts.partsInfo') }}
      </h4>
      <div class="float-end">
        <McButton
          variant="secondary"
          class="me-2"
          icon="icon-fill_close"
          :text="$t('global.cancel')"
          @click="cancel"
        />

        <McButton
          variant="primary"
          :disabled="disableButton"
          :text="$t('global.save')"
          icon="icon-outline_save"
          @click="save"
        />
      </div>
    </div>

    <FormulateForm ref="formRef" v-model="form">
      <b-skeleton-wrapper :loading="isEdit && loading">
        <template #loading>
          <b-card>
            <b-row class="my-4">
              <b-col sm="12" md="3">
                <b-skeleton width="100%" height="50px" />
              </b-col>
              <b-col sm="12" md="3">
                <b-skeleton width="100%" height="50px" />
              </b-col>
              <b-col sm="12" md="3">
                <b-skeleton width="100%" height="50px" />
              </b-col>
              <b-col sm="12" md="3">
                <b-skeleton width="100%" height="50px" />
              </b-col>
            </b-row>
            <b-row class="my-4">
              <b-col sm="12" md="3">
                <b-skeleton width="100%" height="50px" />
              </b-col>
              <b-col sm="12" md="3">
                <b-skeleton width="100%" height="50px" />
              </b-col>
              <b-col sm="12" md="3">
                <b-skeleton width="100%" height="50px" />
              </b-col>
              <b-col sm="12" md="3">
                <b-skeleton width="100%" height="50px" />
              </b-col>
            </b-row>
          </b-card>
        </template>
        <b-card>
          <b-row class="mb-3">
            <b-col md="3">
              <FormulateInput
                name="name"
                type="text"
                :label="$t('master.parts.sparePartName')"
                :placeholder="`${$t('global.form.enter')} ${$t('master.parts.sparePartName')}`"
                validation-behavior="blur"
                error-behavior="blur"
                validation="required:trim"
              />
            </b-col>
            <b-col md="3">
              <FormulateInput
                name="partTypeId"
                validation="required"
                type="select-resourceful"
                :label="$t('master.parts.sparePartType')"
                :placeholder="`${$t('global.form.select')} ${$t('master.parts.sparePartType')}`"
                validation-behavior="live"
                error-behavior="blur"
                trackBy="partTypeId"
                :optionsGetter="optionsGetter.typeOptions"
                :optionLabelFn="
                  ({ item }) => {
                    return item.type
                  }
                "
                :initialObject="initialObject.partType"
                tabIndex="0"
              />
            </b-col>
            <b-col md="3">
              <FormulateInput
                name="partBrandId"
                validation="required"
                type="select-resourceful"
                :label="$t('master.parts.sparePartBrand')"
                :placeholder="`${$t('global.form.select')} ${$t('master.parts.sparePartBrand')}`"
                validation-behavior="live"
                error-behavior="blur"
                trackBy="partBrandId"
                :optionsGetter="optionsGetter.brandOptions"
                :optionLabelFn="
                  ({ item }) => {
                    return item.brand
                  }
                "
                :initialObject="initialObject.partBrand"
                tabIndex="0"
              />
            </b-col>
            <b-col md="3">
              <FormulateInput
                type="text"
                name="sku"
                :label="$t('master.parts.sku')"
                :placeholder="`${$t('global.form.enter')} ${$t('master.parts.skuno')}`"
              />
            </b-col>
          </b-row>
          <b-row class="mb-3">
            <b-col md="3">
              <FormulateInput
                name="quality"
                type="select-resourceful"
                :label="$t('master.parts.quality')"
                :placeholder="`${$t('global.form.select')} ${$t('master.parts.quality')} ${$t(
                  'global.object.parts'
                )}`"
                validation-behavior="live"
                error-behavior="blur"
                trackBy="value"
                :optionsGetter="optionsGetter.qualityOptions"
                :optionLabelFn="
                  ({ item }) => {
                    return item.label
                  }
                "
                :initialObject="initialObject.quality"
                tabIndex="0"
              />
            </b-col>
            <b-col md="3">
              <FormulateInput
                name="description"
                type="text"
                :label="$t('master.parts.description')"
                :placeholder="`${$t('global.form.enter')} ${$t(
                  'master.parts.text.additional'
                )} ${$t('master.parts.description')}`"
              />
            </b-col>
            <b-col md="3">
              <FormulateInput
                name="unit"
                type="select-resourceful"
                :label="$t('master.parts.unit')"
                :placeholder="`${$t('global.form.select')} ${$t('global.object.or')} ${$t(
                  'global.create'
                )} ${$t('master.parts.unit')}`"
                :multiple="false"
                :taggable="true"
                trackBy="value"
                :optionsGetter="optionsGetter.unitOptions"
                :initialObject="initialObject.unit"
                :optionLabelFn="
                  ({ item }) => {
                    return item.label
                  }
                "
                validation-behavior="live"
                validation="required:trim"
                error-behavior="blur"
                tabIndex="0"
                @addTag="tagCustom"
              />
            </b-col>
            <b-col md="3">
              <FormulateInput
                type="text"
                name="price"
                required
                :label="$t('master.parts.buyingPrice')"
                placeholder="0"
                validation-behavior="live"
                error-behavior="live"
                validation="number"
                prefix
              >
                <template #prefix>
                  <div class="formulate-input-prefix">
                    <span>Rp</span>
                  </div>
                </template>
              </FormulateInput>
            </b-col>
          </b-row>
        </b-card>
      </b-skeleton-wrapper>
    </FormulateForm>
  </Layout>
</template>

<script>
import appConfig from '@/app.config'
import PageHeader from '@/components/page-header'
import Layout from '@/router/layouts/main'
import McButton from '@/components/McButton'
import McButtonBack from '@/components/McButtonBack'
import { Helper } from '@/mixin/helper'
import { GET_PART_BY_ID, CREATE_PART, UPDATE_PART } from '@/services/api/master/spareparts'
import { GET_PART_BRANDS } from '@/services/api/setting/maintenance/parts/brand'
import { GET_PART_TYPES } from '@/services/api/setting/maintenance/parts/type'
import unitOfMeasures from './lib/units'

export default {
  page: {
    title: 'Servis',
    meta: [{ name: 'description', content: appConfig.description }],
  },

  components: {
    Layout,
    PageHeader,
    McButton,
    McButtonBack,
  },

  mixins: [Helper],

  apollo: {
    part: {
      query: GET_PART_BY_ID,
      fetchPolicy: 'no-cache',
      manual: true,
      skip() {
        return !this.$route.params.id
      },
      variables() {
        return {
          filter: {
            partId: Number(this.$route.params.id),
          },
        }
      },
      result({ data, loading }) {
        if (loading || !data) return

        if (data) {
          this.loading = true
          const res = data.part.part
          this.userLogging('Access', this.$route, res.name)

          let unit = this.units.filter((item) => item.value === res.unit)
          if (unit.length == 0 && res.unit) {
            unit.push({
              label: res.unit.charAt(0).toUpperCase() + res.unit.slice(1),
              value: res.unit,
            })
          }

          const quality = this.qualities.filter((item) => item.value === res.quality)

          this.initialObject = {
            partType: res.partType,
            partBrand: res.partBrand,
            quality: quality[0],
            unit: unit[0],
          }

          this.form = {
            name: res.name,
            partTypeId: res.partTypeId,
            partBrandId: res.partBrandId,
            sku: res.sku,
            quality: res.quality,
            description: res.description,
            unit: res.unit,
            price: res.price,
          }

          this.oldData = this.form
          this.loading = false
        }
      },
    },
  },

  data() {
    return {
      loading: true,
      form: {
        name: null,
        partTypeId: null,
        partBrandId: null,
        sku: null,
        quality: null,
        description: null,
        unit: null,
        price: null,
      },
      oldData: {},
      newData: {},
      disableButton: true,
      isEdit: false,
      units: unitOfMeasures,
      qualities: [
        { label: 'Non Pabrikan', value: 'Aftermarket' },
        { label: 'Pabrikan', value: 'Original' },
        { label: 'Replika', value: 'Replica' },
      ],
      initialObject: {
        partType: {},
        partBrand: {},
        quality: {},
        unit: this.units,
      },
    }
  },

  computed: {
    title() {
      return this.$route.name === 'Service Spare Part Add'
        ? this.$t('master.parts.addNewParts')
        : this.$t('master.parts.detailParts')
    },

    items() {
      return [
        {
          text: this.$t('menuitems.masterData.text'),
          to: '/master',
        },
        {
          text: this.$t('master.maintenance'),
          to: '/master/service',
        },
        {
          text:
            this.$route.name === 'Service Spare Part Add'
              ? this.$t('master.parts.addNewParts')
              : this.$t('master.parts.detailParts'),
        },
      ]
    },

    optionsGetter() {
      return {
        typeOptions: async (opts) => {
          const filter = {
            pagination: {
              page: opts.page,
              show: opts.limit,
            },
            search: opts.search,
          }

          const res = await this.$apollo.query({
            query: GET_PART_TYPES,
            fetchPolicy: 'no-cache',
            variables: {
              filter: filter,
            },
          })

          const data = res.data.partTypes.partTypes
          const result = {
            metadata: {
              total_count: data.pagination.total,
              page: data.pagination.page,
            },
            data: {
              paginated_result: data.data,
            },
          }

          const self = this
          self.initialObject.partTypes = data.data

          return result
        },
        brandOptions: async (opts) => {
          const filter = {
            pagination: {
              page: opts.page,
              show: opts.limit,
            },
            search: opts.search,
          }

          const res = await this.$apollo.query({
            query: GET_PART_BRANDS,
            fetchPolicy: 'no-cache',
            variables: {
              filter: filter,
            },
          })

          const data = res.data.partBrands.partBrands
          const result = {
            metadata: {
              total_count: data.pagination.total,
              page: data.pagination.page,
            },
            data: {
              paginated_result: data.data,
            },
          }

          const self = this
          self.initialObject.partBrands = data.data

          return result
        },
        qualityOptions: (opts) => {
          let qualities = this.qualities
          if (opts.search) {
            qualities = qualities.filter((item) => this.isContains(opts.search, item.label))
          }
          return {
            metadata: {
              total_page: 1,
              total_count: 5,
              page: 1,
            },
            data: {
              paginated_result: qualities,
            },
          }
        },
        unitOptions: (opts) => {
          let units = this.units
          if (opts?.search) {
            units = units.filter((item) => this.isContains(opts.search, item.label))
          }
          return {
            metadata: {
              total_page: 1,
              total_count: 5,
              page: 1,
            },
            data: {
              paginated_result: units,
            },
          }
        },
      }
    },
  },

  watch: {
    form: {
      deep: true,
      handler(value) {
        if (this.isEdit) {
          if (Object.entries(this.oldData).toString() !== Object.entries(value).toString()) {
            this.disableButton = false
          } else this.disableButton = true
        } else this.disableButton = false
      },
    },
    '$route.params.id': {
      handler(value) {
        if (value) {
          this.isEdit = true
        }
      },
    },
  },

  created() {
    if (this.$route.params.id) {
      this.isEdit = true
    }
  },

  methods: {
    async save() {
      this.form = {
        ...this.form,
        price: +this.form.price,
      }

      this.newData = this.form

      if (this.$refs.formRef.hasErrors) {
        this.$refs.formRef.showErrors()
        return
      }

      if (this.isEdit) {
        const res = await this.$apollo.mutate({
          mutation: UPDATE_PART,
          variables: {
            input: {
              partId: +this.$route.params.id,
              oldData: this.oldData,
              newData: this.newData,
            },
          },
        })

        if (!res.data.updatePart.isSuccessful) {
          this.$mcToast.error(res.data.updatePart.message)
          return
        } else this.$mcToast.success('Data berhasil diubah')
      } else {
        const res = await this.$apollo.mutate({
          mutation: CREATE_PART,
          variables: {
            input: this.form,
          },
        })

        if (!res.data.createPart.isSuccessful) {
          this.$mcToast.error(res.data.createPart.message)
          return
        } else this.$mcToast.success('Data berhasil ditambahkan')

        this.$router.push({
          name: 'Service Spare Part Update',
          params: { id: res.data.createPart.createPart.partId },
        })
      }
    },

    handleBack() {
      this.cancel()
      this.$router.push({ name: 'Master Service' })
    },

    cancel() {
      if (this.isEdit) {
        this.form = this.oldData
      } else {
        this.form = {
          name: null,
          partTypeId: null,
          partBrandId: null,
          sku: null,
          quality: null,
          description: null,
          unit: null,
          price: null,
        }
      }
    },
    tagCustom(newTag) {
      const tag = {
        label: newTag,
        value: newTag.toLowerCase(),
      }

      this.units.push(tag)
      this.form.unit = tag.value
    },
  },
}
</script>
